import { render } from "./lector-codigo.vue?vue&type=template&id=406cfd3c&scoped=true"
import script from "./lector-codigo.vue?vue&type=script&lang=js"
export * from "./lector-codigo.vue?vue&type=script&lang=js"

import "./lector-codigo.vue?vue&type=style&index=0&id=406cfd3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406cfd3c"]])

export default __exports__